import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { SOCIOS_NUEVO, SOCIOS_LISTA } from 'constants/codigosTransacciones'

import ListaPage from './lista'
import NuevoPage from './nuevo'

export default function SociosPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${SOCIOS_NUEVO}/:id`} component={NuevoPage} />
        <Route path={`/${SOCIOS_NUEVO}`} component={NuevoPage} />
        <Route path={`/${SOCIOS_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
